import { normalizeOperatorNaming } from '@entities/operator';

export default Backbone.Model.extend({
    defaults: {
        id: null,
        name: null,
        cover: null,
    },
    initialize({ id, name = null, nameRu = null }) {
        const operator = normalizeOperatorNaming({ id, name, nameRu });
        this.set({
            cover: `${window.appConfig.imagesDomain}/photos/operator/${id}.png`,
            name: operator.name,
            nameRu: operator.nameRu,
        });
    },
});
